import React from 'react';
import { Title, Subtitle } from "../../styles/text";
import { Message } from "../../locale/Message";
import { Button } from "../../features/shared";
import styled from "styled-components";

const BtnRoot = styled.div`
 		margin-top: 40px;
`

const AuletRoot = styled.div`
    margin-top: 120px;
    @media screen and (max-width: 640px) {
        margin-top: 20px;
    }
`

const Aulet = ({ lang }) => {
	return (
		<AuletRoot>
			<Title>
				{Message.auletTitle[lang]}
			</Title>
			<Subtitle>
				{Message.auletSubtitle[lang]}
			</Subtitle>
			<BtnRoot>
				<Button
					onClick={() => window.open(`https://www.kcell.kz/${lang}/profile?login=true`, '_self')}
					text={Message.signIn[lang]}
					type="kcell"
				/>
			</BtnRoot>
		</AuletRoot>
	);
};

export default Aulet;
